<ion-list [formGroup]="parent">
  <ion-item>
    <ion-select
      class="bepatient_dynamic_form_select"
      interface="popover"
      [interfaceOptions]="customPopoverOptions"
      [placeholder]="'PICK_ONE' | translate"
      [formControlName]="question.key"
      [id]="question.key"
      [attr.disabled]="question.disabled || question.readonly"
      [cancelText]="question.cancelText | translate"
      [okText]="question.okText | translate"
    >
      <ion-select-option
        *ngFor="let option of question.options"
        [value]="option.name"
      >
        {{ option.value }}
      </ion-select-option>
    </ion-select>
  </ion-item>
</ion-list>
